import { BaseDialog } from "./dialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { DatePicker } from "../ui/date-picker";
import { createBatchInvoiceSession } from "@/service/weexpertService";
import { useMutation } from "react-query";
import { toast } from "../ui/use-toast";
import { format } from "date-fns";

export function BatchInvoiceSessionPopup() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(new Date());

  const mutation = useMutation({
    mutationFn: (dateStr) => createBatchInvoiceSession(dateStr, dateStr, dateStr),
    onSuccess: (response) => {
      toast({
        title: t("invoices:batch_session_success"),
      });
      setOpen(false);
      navigate(`/admin/batch-invoice-session/${response.data.id}`);
    },
    onError: (error) => {
      const message = error.response?.data?.error || error.response?.data?.message || t("invoices:batch_session_error");
      toast({
        title: t("invoices:batch_session_error"),
        description: message,
        variant: "destructive",
      });
    },
  });

  const handleSubmit = () => {
    const dateStr = format(date, "yyyy-MM-dd");
    mutation.mutate(dateStr);
  };

  return (
    <BaseDialog
      dialogTitle={t("invoices:batch_session_title")}
      buttonText={t("invoices:batch_session_button")}
      open={open}
      setOpen={setOpen}
      className="text-[12px] md:text-sm mt-2 md:mt-0"
    >
      <div className="max-w-[400px] flex flex-col items-end pt-4">
        <div className="w-full pb-4">
          <DatePicker
            date={date}
            setDate={setDate}
            label={t("invoices:batch_session_date_label")}
          />
        </div>
        <Button
          disabled={mutation.isLoading}
          onClick={handleSubmit}
        >
          {t("invoices:batch_session_button")}
        </Button>
      </div>
    </BaseDialog>
  );
}
